export enum FeatureFlag {
	enableStatusField = 'dt_enable_status_field',
	enableDTExportTemplate = 'export_template',
}
